// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e8a069d4","977":"d087e7b0"}[chunkId] + ".chunk.js";
};